export default __webpack_public_path__ + "9f6dd7cadd5c83b13fcad2e5e4e621e6.svg";